import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row mb-2 mb-xl-3" }
const _hoisted_2 = { class: "col-auto ms-auto text-end mt-1 d-flex" }
const _hoisted_3 = { class: "overflow-hidden" }
const _hoisted_4 = {
  class: "bg-white position-relative overflow-auto mw-100 pb-6",
  style: {"max-height":"650px"}
}
const _hoisted_5 = { class: "table table-bordered" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", { class: "sticky-top bg-white" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "position-relative border-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Дата тендера"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Проект (лот)"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Стоимость без НДС"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "НДС"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Стоимость c НДС"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Условия участия"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Условия контракта"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Себестоимость"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Маржа"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Рентабельность (%)"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Примечание"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Действия")
  ])
], -1)
const _hoisted_7 = { class: "p-2" }
const _hoisted_8 = { class: "p-2" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { key: 2 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "p-2 text-end" }
const _hoisted_18 = { class: "p-2 text-end" }
const _hoisted_19 = { class: "p-2 text-end" }
const _hoisted_20 = { class: "p-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "p-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = { class: "p-2 text-end" }
const _hoisted_34 = { class: "p-2 text-end" }
const _hoisted_35 = { class: "p-2 text-end" }
const _hoisted_36 = { class: "p-2" }
const _hoisted_37 = { class: "p-2" }
const _hoisted_38 = { class: "btn btn-sm d-flex justify-content-center align-items-center" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", {
  class: "p-2 text-center",
  colspan: "12"
}, "Данных нет", -1)
const _hoisted_41 = [
  _hoisted_40
]

import { reactive, onMounted } from 'vue';
import { useModal } from '@/composables/useModal';
import api from '@/api';
import { IProjectRegister } from '@/@types/IProjectRegister';
import formatDate from '@/utils/formatDate';
import formatMoney from '@/utils/formatMoney';

type stateType = {
    projectRegisters: Array<IProjectRegister>;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectRegisterComponent',
  setup(__props) {

const state: stateType = reactive({
    projectRegisters: [],
});

function getProjectRegisters() {
    return api.projectRegister.getMany().then(({ data }) => {
        state.projectRegisters = data;
    });
}

onMounted(getProjectRegisters);

function handleCreateProjectRegister() {
    useModal('project_register_modal')
        .open({ type: 'add' })
        .then(getProjectRegisters)
        .catch((e) => console.log(e));
}

function handleEditProjectRegister(projectRegister: IProjectRegister) {
    useModal('project_register_modal')
        .open({ type: 'edit', projectRegister })
        .then(getProjectRegisters)
        .catch((e) => {
            console.log(e);
        });
}

function handleCalculateConstructivePrice(projectRegister: IProjectRegister) {
    useModal('project_register_price_modal')
        .open({ projectRegister })
        .then(getProjectRegisters)
        .catch((e) => {
            console.log(e);
        });
}

function handleOpenDatasheetModal(projectRegister: IProjectRegister) {
    useModal('project_register_datasheet_modal')
        .open({ projectRegister })
        .then(getProjectRegisters)
        .catch((e) => {
            console.log(e);
        });
}

return (_ctx: any,_cache: any) => {
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_dropdown_ui = _resolveComponent("dropdown-ui")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_button_ui, {
          "button-class": "btn-primary ms-3 btn-sm",
          onClick: handleCreateProjectRegister
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Создать ")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (state.projectRegisters.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.projectRegisters, (projectRegister) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: projectRegister.id
                  }, [
                    _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(formatDate)(projectRegister.tenderStartsAt)), 1),
                    _createElementVNode("td", _hoisted_8, [
                      (projectRegister.portal)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                            _createTextVNode(" Портал: " + _toDisplayString(projectRegister.portal) + " ", 1),
                            _hoisted_10
                          ]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" Клиент: " + _toDisplayString(projectRegister.contractor.name
                                        ?.replaceAll(' ', '\xa0')
                                        .replaceAll('-', '‑')), 1),
                      _hoisted_11,
                      _createTextVNode(" ПС: " + _toDisplayString(projectRegister.locomotiveModel.name) + " ", 1),
                      (projectRegister.locomotiveId)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Гос.номер: " + _toDisplayString(projectRegister.locomotive?.number), 1))
                        : _createCommentVNode("", true),
                      _hoisted_13,
                      _createTextVNode(" Вид работ: " + _toDisplayString(projectRegister.jobCategory.name?.replaceAll('-', '‑')), 1),
                      _hoisted_14,
                      (projectRegister.entersAt)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, " Дата заезда: " + _toDisplayString(_unref(formatDate)(projectRegister.entersAt)), 1))
                        : _createCommentVNode("", true),
                      _hoisted_16
                    ]),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formatMoney)(+projectRegister.totalWithoutVAT, 0, '.', '\xa0')), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(formatMoney)(projectRegister.vat, 0, '.', '\xa0')), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(formatMoney)(projectRegister.total, 0, '.', '\xa0')), 1),
                    _createElementVNode("td", _hoisted_20, [
                      _createElementVNode("span", null, "ОИД: " + _toDisplayString(projectRegister.oidPercent) + "%", 1),
                      _hoisted_21,
                      _createElementVNode("span", null, " Тендерное обеспечение: " + _toDisplayString(projectRegister.tenderSecurityPercent) + "% ", 1),
                      _hoisted_22,
                      (projectRegister.qualificationRequirements?.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Квал.требования: " + _toDisplayString(projectRegister.qualificationRequirements), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_24, [
                      _createTextVNode(" Аванс: " + _toDisplayString(projectRegister.advancePercent) + "% ", 1),
                      _hoisted_25,
                      _createTextVNode(" Оплата после сдачи АВР: " + _toDisplayString(projectRegister.daysToGetPaidAfterActOfWorkPerformedSubmit) + " дн.", 1),
                      _hoisted_26,
                      _createTextVNode(" Срок ремонта: " + _toDisplayString(projectRegister.repairPeriodDays) + " дн.", 1),
                      _hoisted_27,
                      _createTextVNode(" Полная оплата: " + _toDisplayString(projectRegister.fullPayment), 1),
                      _hoisted_28,
                      _createTextVNode(" Пеня за простой: " + _toDisplayString(projectRegister.demuragePenalty) + "%", 1),
                      _hoisted_29,
                      _createTextVNode(" Оплата сцерхцикла: " + _toDisplayString(projectRegister.isOvercyclePaid ? 'Да' : 'Нет'), 1),
                      _hoisted_30,
                      _createTextVNode(" Установка доп. оборудования:: " + _toDisplayString(projectRegister.isAdditionalEquipmentInstalled ? 'Да' : 'Нет'), 1),
                      _hoisted_31,
                      _createTextVNode(" Спец условия: " + _toDisplayString(projectRegister.isSpecialConditions ? 'Да' : 'Нет'), 1),
                      _hoisted_32
                    ]),
                    _createElementVNode("td", _hoisted_33, _toDisplayString(_unref(formatMoney)(projectRegister.costPrice, 0, '.', '\xa0')), 1),
                    _createElementVNode("td", _hoisted_34, _toDisplayString(_unref(formatMoney)(projectRegister.margin, 0, '.', '\xa0')), 1),
                    _createElementVNode("td", _hoisted_35, _toDisplayString(_unref(formatMoney)(projectRegister.profitability, 0, '.', '\xa0')), 1),
                    _createElementVNode("td", _hoisted_36, _toDisplayString(projectRegister?.comment), 1),
                    _createElementVNode("td", _hoisted_37, [
                      _createVNode(_component_dropdown_ui, null, {
                        button: _withCtx(() => [
                          _createElementVNode("button", _hoisted_38, [
                            _createVNode(_component_vue_feather, {
                              size: "14px",
                              type: "more-vertical"
                            })
                          ])
                        ]),
                        list: _withCtx(() => [
                          _createVNode(_component_button_ui, {
                            class: "dropdown-item cursor-pointer",
                            onClick: ($event: any) => (handleEditProjectRegister(projectRegister))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Редактировать ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_button_ui, {
                            class: "dropdown-item cursor-pointer",
                            onClick: ($event: any) => (handleCalculateConstructivePrice(projectRegister))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Себестоимость ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_button_ui, {
                            class: "dropdown-item cursor-pointer",
                            onClick: ($event: any) => (handleOpenDatasheetModal(projectRegister))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Техническое состояние ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_button_ui, {
                            class: "dropdown-item cursor-pointer",
                            disabled: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Отправить в архив ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("tr", _hoisted_39, _hoisted_41))
          ])
        ])
      ])
    ])
  ], 64))
}
}

})